import React from "react";
import HeroSection from "../containers/CustomDevelopment/HeroSection";
import Section_one from "../containers/CustomDevelopment/Section_one";
import OurProcess from "../containers/CustomDevelopment/OurProcess";
import Tecno from "../containers/CustomDevelopment/Tecno";
import Industry from "../containers/CustomDevelopment/Industries";
import WhyBinaryOps from "../containers/CustomDevelopment/WhyBinaryops";


const customSoftware = () => {
  return (
    <div>
      <HeroSection />
      <Section_one />
      <div className="bg-gradient-to-b from-[#F2FBFE] to-white">

      <OurProcess />
      </div>
      <Tecno />
      <Industry/>
      <WhyBinaryOps/>
   
    </div>
  );
};

export default customSoftware;
